module.exports = __webpack_public_path__ + "img/manutencao.459bf904.png";